/* eslint-disable no-unused-expressions */
import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "axios";
import { toast } from 'react-toastify';

import { API_TOKEN, API_URL } from "../../Config/secrets";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  verifications: {},
  totalVerifications: 0,
  selectedFilters: {
    page: 1,
    filters: {},
  },
};

const slice = createSlice({
  name: "verifications",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    resetBrand: () => initialState,

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.matchingLoading = false;
      state.matchResults = [];
    },

    // GET EVENTS
    getVerificationsSuccess(state, action) {
      state.error = null;
      state.totalVerifications = action.payload.total;
      (state.verifications = {
        ...state.verifications,
        [action.payload.page]: action.payload.data,
      });
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { resetBrand, getverificationsSuccess } =
  slice.actions;

// ----------------------------------------------------------------------

const header = {
  Authorization: API_TOKEN,
};


export function getVerifications(page = 1, take = 10) {
  return async (dispatch) => {
    try {
      let payload = { skip: page, take };
      // const isFilters = Object.keys(filters || {}).length > 0;

      // if (isFilters) {
      //   payload.filters = true;
      //   payload = { ...payload, ...filters };
      // }
      // if (query) payload.query = query;

      const response = await axios.post(`${API_URL}/brands/get-verifications`, payload, {
        headers: header,
      });

      console.log('get-verifications response', response.data)
      // if (response?.data?.statusCode === 200) {
      dispatch(
        slice.actions.getVerificationsSuccess({
          page,
          total: response?.data?.data?.count || 0,
          data: response?.data?.data?.data || [],
        })
      );
      return response?.data?.data?.data;
      // }
    } catch (error) {
      toast.error(error?.message || "Failed to fetch wholesalers", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function updateVerifications(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/brands/update-verifications`, data, {
        headers: header,
      });

      console.log('updateVerifications response', response.data)
      return response?.data;
      // }
    } catch (error) {
      toast.error(error?.message || "Failed to fetch wholesalers", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}